import { render, staticRenderFns } from "./DownloadOption.vue?vue&type=template&id=1ff61136&scoped=true"
import script from "./DownloadOption.vue?vue&type=script&lang=js"
export * from "./DownloadOption.vue?vue&type=script&lang=js"
import style0 from "./DownloadOption.vue?vue&type=style&index=0&id=1ff61136&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ff61136",
  null
  
)

export default component.exports